import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

// Full-page skeleton shown while the Model chunk downloads and initial data loads
export const ModelPageSkeleton = () => (
    <Container
        maxWidth={false}
        sx={{
            maxWidth: { xs: '100%', md: '1200px' },
            px: { xs: 1, md: 3 }
        }}
    >
        <Box sx={{ my: { xs: 1, md: 2 } }}>
            <Grid container spacing={{ xs: 1, md: 2 }}>
                {/* Model viewer skeleton */}
                <Grid item xs={12} md={8}>
                    <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
                        <Skeleton
                            variant="rounded"
                            animation="wave"
                            sx={{ height: { xs: 400, md: 600 }, borderRadius: 2 }}
                        />
                    </Card>
                </Grid>

                {/* Specifications table skeleton */}
                <Grid item xs={12} md={4}>
                    <Card sx={{ borderRadius: 2, boxShadow: 2, height: { xs: 'auto', md: 600 } }}>
                        <CardContent>
                            <Stack spacing={2}>
                                <Skeleton variant="text" animation="wave" width={120} height={28} />
                                {[100, 90, 110, 80, 95, 105].map((w, i) => (
                                    <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Skeleton variant="text" animation="wave" width={w} />
                                        <Skeleton variant="text" animation="wave" width={60} />
                                    </Box>
                                ))}
                                <Skeleton variant="rounded" animation="wave" height={44} width="100%" />
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Description section skeleton */}
                <Grid item xs={12}>
                    <Card sx={{ borderRadius: 2, boxShadow: 2, minHeight: { xs: 400, md: 500 } }}>
                        <CardContent>
                            {/* Title */}
                            <Skeleton variant="text" animation="wave" width={250} height={32} />
                            {/* Description paragraph lines */}
                            <Skeleton variant="text" animation="wave" width="90%" />
                            <Skeleton variant="text" animation="wave" width="80%" />
                            <Skeleton variant="text" animation="wave" width="85%" />
                            <Skeleton variant="text" animation="wave" width="70%" />
                            {/* "What's Included" heading */}
                            <Skeleton variant="text" animation="wave" width={200} height={28} sx={{ mt: 3 }} />
                            {/* List items (icon + two lines each) */}
                            {[1, 2, 3, 4].map((_, i) => (
                                <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mt: 2 }}>
                                    <Skeleton variant="circular" animation="wave" width={24} height={24} sx={{ mt: 0.5, flexShrink: 0 }} />
                                    <Box sx={{ flex: 1 }}>
                                        <Skeleton variant="text" animation="wave" width="40%" height={24} />
                                        <Skeleton variant="text" animation="wave" width="80%" />
                                    </Box>
                                </Box>
                            ))}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    </Container>
);
